module.exports = __webpack_public_path__ + "b90917fa9a36c67988cd93b6d14fe206.png";